import FundingSetup from "./FundingSetup";
import { connect } from "react-redux";
import {
  getSelectedParticipant,
  getSelectedParticipantOnBoardingProgress,
} from "../../../../store/selector/participant.selector";
import {
  storeAndUpdateFundingSetupRequest,
  getFundingSetupRequest,
  catalogVersionRequest,
  checkFundingManagementImpactRequest,
  clearFundingManagementImpactCheck,
  deleteFundingSetupRequest,
} from "../../../../store/actions/cos.actions";
import {
  getCatalogVersions,
  getCOSLoader,
  getParticipantFundings,
  getParticipantFundingsLoading,
  getStoreFundingSetupLoading,
  getStoreFundingSetupError,
  getFundingManagementImpactCheck,
  getDeleteFundingLoading,
} from "../../../../store/selector/cos.selector";

const mapDispatchToProps = {
  storeAndUpdateFundingSetupRequest,
  getFundingSetup: getFundingSetupRequest,
  getCatalogVersions: catalogVersionRequest,
  checkFundingManagementImpactRequest,
  clearFundingManagementImpactCheck,
  deleteFundingSetupRequest,
};

const mapStateToProps = (state) => {
  const participant = getSelectedParticipant(state);
  const fundingSetupLoading = getStoreFundingSetupLoading(state);
  const participantFundings = getParticipantFundings(state);
  const participantFundingsLoading = getParticipantFundingsLoading(state);
  const participantOnBoarding = getSelectedParticipantOnBoardingProgress(state);
  const catalogVersions = getCatalogVersions(state);
  const catalogVerionLoading = getCOSLoader(state);
  const storeAndUpdateError = getStoreFundingSetupError(state);
  const fundingManagementImpactCheck = getFundingManagementImpactCheck(state);
  const deleteFundingLoading = getDeleteFundingLoading(state);

  return {
    participantFundings,
    participant,
    fundingSetupLoading,
    participantFundingsLoading,
    participantOnBoarding,
    catalogVersions,
    catalogVerionLoading,
    storeAndUpdateError,
    fundingManagementImpactCheck,
    deleteFundingLoading,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FundingSetup);
